module.exports = __webpack_public_path__ + "img/subestaciones_e.224a58f8.png";